import React, { ReactNode } from 'react'
import styled from '@emotion/styled'

interface HeroSection {
  children?: ReactNode
}

const SIDE_PADDING = 4

/**
 * Mainly used for a schedulable page.
 */
const HeroSection = ({ children }: HeroSection) => {
  return <StyleHero>{children}</StyleHero>
}

export default HeroSection

export const HeroSectionContainer = styled.div(({ theme }) => ({
  paddingRight: theme.space[SIDE_PADDING],
  paddingLeft: theme.space[SIDE_PADDING],
  ...theme.mixins.centeredContainer(theme.currentMaxWidth)
}))

export const HeroSectionContainerRow = styled.div(({ theme }) => ({
  marginBottom: theme.space[3],
  paddingBottom: theme.space[3],
  borderBottom: theme.border
}))

const StyleHero = styled.section(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.space[5],
  "& > div[role='img']": {
    marginBottom: theme.space[3]
  }
}))
